// extracted by mini-css-extract-plugin
module.exports = {"container":"demos-list-module--container--1A9cu","subTitle":"demos-list-module--subTitle--FH-eI"};